import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageRef, NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export interface CwtSnackbarData {
  message?: string;
  params?: any;
  type?: string;
  autoDismiss?: boolean;
}

@Injectable({ providedIn: 'root' })
export class CwtSnackbarService {

  constructor(
    private translate: TranslateService,
    private snackbar: NzMessageService
  ) { }

  public dismiss(ref: NzMessageRef) {
    this.snackbar.remove(ref?.messageId);
  }

  public wrapWithLoading<T>(source: Observable<T>, message: string, params?: any): Observable<T> {
    const loading = this.loading(message, params, false);
    return source.pipe(
      finalize(() => this.dismiss(loading))
    );
  }

  public loading(message: string, params?: any, autoDismiss = true) {
    return this._open({
      message: message,
      params: params,
      type: 'loading',
      autoDismiss
    });
  }

  public success(message: string, params?: any, autoDismiss = true) {
    return this._open({
      message: message,
      params: params,
      type: 'success',
      autoDismiss
    });
  }

  public info(message: string, params?: any, autoDismiss = true) {
    return this._open({
      message: message,
      params: params,
      type: 'info',
      autoDismiss
    });
  }

  public error(message: string, params?: any, autoDismiss = true) {
    return this._open({
      message: message,
      params: params,
      type: 'error',
      autoDismiss
    });
  }

  private _open(data: CwtSnackbarData) {
    const i18n = this.translate.instant(data?.message, data?.params);
    const snack = this.snackbar.create(data?.type, i18n, {
      nzAnimate: true,
      nzDuration: data?.autoDismiss ? 3000 : 0,
      nzPauseOnHover: true
    });
    return snack;
  }
}
